const BUCKET_NAME = 'geo_distance';

export default class ThingLocationController {
    /** @ngInject */
    constructor(GeoService, EventEmitter) {
        this.GeoService = GeoService;
        this.eventEmitter = EventEmitter;
    }

    $onInit() {
        this.mapOptions = {
            scrollwheel: false
        };

        this.locationEnabled = false;
        this.distance = null;
        this.location = null;
        this.marker = {};
        this.centerCoordinates = {};
        this.geo = navigator.geolocation;
        this.defaultCoordinates = this.GeoService.getCoordsByKey('default') || {};

        this.defineCoordinates();
    }

    changed() {
        if (this.locationEnabled && this.distance && this.location) {
            this.addItemToBucket(
                this.eventEmitter({
                    item: {
                        name: BUCKET_NAME,
                        value: {
                            distance: this.distance,
                            location: this.location
                        }
                    }
                })
            );
        } else {
            this.removeItemFromBucket(
                this.eventEmitter({
                    item: {
                        name: BUCKET_NAME
                    }
                })
            );
        }
    }

    boundsChanged({ bounds }) {
        const distance = Math.round(this.GeoService.getDistanceBetweenCoords(
            bounds.southWest.lat,
            bounds.southWest.lng,
            bounds.northEast.lat,
            bounds.northEast.lng
        ) * 0.2);
        this.distance = `${distance}m`;
        this.changed();
    }

    centerChanged({ center: { lat, lng } }) {
        this.location = {
            lat,
            lon: lng
        };
        this.changed();
    }

    defineCoordinates() {
        this.geo.getCurrentPosition((position) => {
            this.centerCoordinates.lat = position.coords.latitude;
            this.centerCoordinates.lng = position.coords.longitude;
        }, () => {
            // TODO: by default Oslo coordinates
            this.centerCoordinates.lat = this.defaultCoordinates.lat;
            this.centerCoordinates.lng = this.defaultCoordinates.lng;
        });
    }
}



// WEBPACK FOOTER //
// ./app/components/sensors-and-connectors/components/search/advanced/thing-location/thing-location.controller.js